import { render, staticRenderFns } from "./AvailableBalance.vue?vue&type=template&id=f2edef84"
import script from "./AvailableBalance.vue?vue&type=script&lang=js"
export * from "./AvailableBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports